const baseURL = 'https://invtfm5.ma/api'
// const baseURL = 'http://127.0.0.1:8000/api'

export default baseURL